import { render, staticRenderFns } from "./IndicadorDecisaoCredito.vue?vue&type=template&id=b593d53c&"
import script from "./IndicadorDecisaoCredito.vue?vue&type=script&lang=js&"
export * from "./IndicadorDecisaoCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports